import React from 'react';
import type { SwampEvent } from '../types';
import { EventScoreCard } from './EventScoreCard';

interface EventScoreListProps {
   events: SwampEvent[];
   teamNames: string[];
}

export function EventScoreList({ events, teamNames }: EventScoreListProps) {
   return (
      <section className="swamp-section">
         <h2 className="swamp-section__title">Events</h2>
         <div className="swamp-event-list">
            {events.map((event) => (
               <EventScoreCard key={event.name} event={event} teamNames={teamNames} />
            ))}
         </div>
      </section>
   );
}
